/**
 * CouncilsStrategyModal Component - By John Bellew - Infinia.ie - last updated 10/07/2025
 * 
 * A modal component for displaying Council Strategy information with:
 * - Strategic objectives and pillar details
 * - Color-coded topic headers
 * - Keyboard navigation (Escape key support)
 * - Responsive design for various screen sizes
 * - HTML content parsing for rich text display
 * 
 * @param {Object} data - Array containing strategy data for display
 * @param {string} title - Title for the modal header
 * @param {boolean} show - Whether the modal is visible
 * @param {function} onClose - Callback function when modal is closed
 * @param {string} selectedColour - CSS class for color theming
 * @param {string} topPillar - Optional top pillar title override
 * @returns {JSX.Element|null} Modal component or null if not shown
 */
import React, { useEffect, useState } from 'react';
import Parser from 'html-react-parser';
import './Modal.css';
import './CouncilsStrategyModal.css';

/**
 * CouncilsStrategyModal component for displaying strategic council information
 * with customizable theming and keyboard navigation support
 */
function CouncilsStrategyModal({ data, title,  show, onClose, selectedColour, topPillar}) {
    data = data[0];
    
    /**
     * Effect hook to handle keyboard navigation
     * Sets up and cleans up event listener for Escape key
     */
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        window.addEventListener('keydown', handleEscape);
        return () => window.removeEventListener('keydown', handleEscape);
    }, [onClose]);

    if (!show) return null;

    return (
        <div className="councils-strategy-modal">
            <div className="modal-content">
                <div className="modal-header">
                    <span id="modalTitle">{topPillar ? topPillar : title}</span>
                        <span
                            className="modalclose pointer fas fa-times"
                            onClick={onClose}
                        ></span>
                </div>
                <div className="modal-body pb-10">
                    <div className={selectedColour ? 'topictitle ' + selectedColour : 'topictitle'}>
                        <h3 className='pillar-header'>{data.topic}</h3>
                    </div>                 

                    <div className="summary">
                        
                        <div>{Parser(data.strategicObjective || 'No Strategic Objective available')}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CouncilsStrategyModal;
